export default [
  {
    name: 'settlement',
    path: '/settlement',
    component() {
      return import('@/pages/settlement/SettlementHistory.vue')
    },
  },
  {
    name: 'earlypay',
    path: '/earlypay',
    meta: { design: { classes: ['bg--linear-gradient'] } },
    component() {
      return import('@/pages/settlement/Earlypay2.vue')
    },
  },
  {
    name: 'earlypay-intro',
    path: '/earlypay-intro',
    meta: { design: { classes: ['bg--linear-gradient'] } },
    component() {
      return import('@/pages/settlement/EarlypayIntro.vue')
    },
  },
  {
    name: 'earlypay-check',
    path: '/earlypay-check',
    meta: { design: { classes: ['bg--linear-gradient'] } },
    component() {
      return import('@/pages/settlement/EarlypayCheck.vue')
    },
  },
  {
    name: 'sales',
    path: '/sales',
    meta: { design: { classes: ['bg--linear-gradient'] } },
    component() {
      return import('@/pages/sales-info/SalesPage.vue')
    },
  },
  {
    name: 'earlypay/statistics/month',
    path: '/earlypay/statistics/month',
    component() {
      return import('@/pages/settlement/MonthlyEarlypayStatistics.vue')
    },
  },
  {
    name: 'earlypay/statistics/month-sales',
    path: '/earlypay/statistics/month-sales',
    component() {
      return import('@/pages/sales-info/MonthlySalesStatistics.vue')
    },
  },
]
